import { render, staticRenderFns } from "./CompButtonIconText.vue?vue&type=template&id=3f566339&scoped=true"
import script from "./CompButtonIconText.vue?vue&type=script&setup=true&lang=js"
export * from "./CompButtonIconText.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f566339",
  null
  
)

export default component.exports